import webview from '@adapter/webview';
import { ArrowBack } from '@groww-tech-pvt/icon-store/mi';

import { ONBOARDING_FLOW_SCREENS } from 'core/constants';
import { isNriPathJourney } from 'core/helpers';
import { getSearchParams } from 'core/hooks/useGetParam';
import useOnboardingStore from 'core/store';
import { getDomainConfig, getIsDomain915 } from 'src/utils/config/domainConfig';
import { useRedirectToPreviousPage } from 'src/utils/hook';
import { ROUTES } from 'src/utils/constants/routes';
import { useUserDataStore } from 'src/utils/store/UserData';

import { Header915 } from './Header915';
import OnboardingBackPopup from './OnboardingBackPopup';
import OnbImage from 'src/components/Image';
import { ONBOARDING_IMAGES } from 'core/assets';
import { ToastContainer } from 'src/components/Toast';

const OnboardingProvider = ({ children }: { children: React.ReactNode }) => {
  const WV = webview();
  const isMsite = typeof window !== 'undefined' && window.innerWidth < 768;
  const domain = getDomainConfig();
  const isDomain915 = getIsDomain915();
  // This is reqd to check if NRI Rupeeflo journey is active, to adjust the container height & width accordingly.
  const { journeyType } = getSearchParams();
  const { userData } = useUserDataStore();
  const isNriPath = typeof window !== 'undefined' && window.location.pathname === ROUTES.NRI_ONBOARDING;
  const isNriRupeefloJourney = isNriPathJourney(journeyType, userData?.account_type, isNriPath);
  const setIsExitPopupOpen = useOnboardingStore(s => s.setIsExitPopupOpen);
  const activeScreen = useOnboardingStore(s => s.activeScreen);
  const hideHistoryBackPopup = useOnboardingStore(s => s.hideHistoryBackPopup);
  const { goBackToPreviousPage } = useRedirectToPreviousPage('BACK_POPUP');

  const skipExitIntercept =
    activeScreen === ONBOARDING_FLOW_SCREENS.SUCCESS_SCREEN ||
    activeScreen === ONBOARDING_FLOW_SCREENS.ONBOARDING_PENDING_SCREEN ||
    hideHistoryBackPopup;

  const onBackClick = () => {
    if (skipExitIntercept) {
      goBackToPreviousPage();
      return;
    }
    setIsExitPopupOpen(true);
  };

  const getHeader = () => {
    switch (domain.appId) {
      case 'GrowwWeb':
        return (
          <div className="w-full flex py-4 pl-3 px-5 justify-between absolute top-0 stretch z-1">
            {WV.isActive || isMsite ? (
              <ArrowBack
                color="contentPrimary"
                size={22}
                onClick={onBackClick}
              />
            ) : (
              <OnbImage
                src={ONBOARDING_IMAGES.GROWW_LOGO}
                width={'auto'}
                height={'auto'}
                className="h-[4vh] min-h-0.5 cursor-pointer "
                onClick={onBackClick}
              />
            )}
          </div>
        );
      case '915Web':
        return <Header915 />;

      default:
        return <></>;
    }
  };

  return (
    <div className={`relative flex flex-col min-h-screen overflow-hidden`}>
      {/* Hide SVG grid pattern on narrow viewports (msite): solid body bg behind header */}
      <OnbImage
        src={ONBOARDING_IMAGES.PATTERN_BG}
        width={100}
        height={100}
        className={`hidden md:block w-full h-full object-cover absolute bottom-0 left-0 blur-[1px] ${!isDomain915 ? 'backgroundPrimary' : ''}`}
      />

      {getHeader()}
      <div className={`absolute inset-x-0 flex justify-center top-[6%] ${isNriRupeefloJourney ? 'md:top-3 lg:top-[2%]' : 'md:top-13.5 lg:top-[10%]'}`}>
        <div
          className={`${isNriRupeefloJourney ? 'lg:w-270 md:w-195' : 'lg:w-210 md:w-155'} w-full
           sm:w-[80%] sm:backdrop-blur-xl lg:p-5 p-3 sm:pt-3 sm:mt-16 rounded-lg!
           h-[94vh] sm:h-225 ${isNriRupeefloJourney ? 'md:h-[80vh] lg:h-[80vh]' : 'md:h-[70vh] lg:h-[70vh]'} 
           ${!isDomain915 ? 'backgroundSecondary glass' : 'backgroundPrimary gradient-bg glass'} overflow-y-auto`}
        >
          {children}
        </div>
      </div>

      <OnboardingBackPopup />
      <ToastContainer />
    </div>
  );
};

export default OnboardingProvider;
